export const EDITOR_ACTIONS = {
  UPDATE_TRACES: 'plotly-editor-update-traces',
  ADD_TRACE: 'plotly-editor-add-trace',
  DELETE_TRACE: 'plotly-editor-delete-trace',
  UPDATE_LAYOUT: 'plotly-editor-update-layout',
};

export const DEFAULT_FONTS = [
  {label: 'Arial', value: 'Arial, Roboto, sans-serif'},
  {
    label: 'Courier New',
    value: '"Courier New", Courier, "Droid Sans Mono", monospace',
  },
  {label: 'Times', value: '"Times New Roman", Times, "Droid Serif", serif'},
  {label: 'Futura', value: '"Century Gothic", Futura, Roboto, sans-serif'},
  {label: 'Georgia', value: 'Georgia, "Droid Serif", serif'},
  {label: 'Open Sans', value: '"Open Sans", verdana, arial, sans-serif'},
];
